import { render } from "./ProjectsModal.vue?vue&type=template&id=2a7bc3c7&scoped=true"
import script from "./ProjectsModal.vue?vue&type=script&lang=js"
export * from "./ProjectsModal.vue?vue&type=script&lang=js"

import "./ProjectsModal.vue?vue&type=style&index=0&id=2a7bc3c7&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a7bc3c7"]])

export default __exports__